import React, {useState, useRef, useEffect} from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import themeStyles from "../../../_common/styles/theme.module.scss";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {useGlobalContext} from "../../contexts/GlobalContext";

export const ButtonDD = ({label, items, menuPosition = 'right'}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const {isGlassTheme} = useGlobalContext();

  return (
    <div className={styles.dropdown} ref={ref}>
      <button
        className={classNames(styles.button, isGlassTheme ? themeStyles.jump : themeStyles.noJump)}
        onClick={() => setOpen(v => !v)}
      >
        {label
          ? label
          : <img src={toAbsoluteUrl('/media/common/Dots_primary.svg')} alt="dots"/>
        }
      </button>
      <div className={classNames(
        styles.menu,
        open ? styles.openMenu : '',
        menuPosition === 'right' ? styles.menuRight : styles.menuLeft,
        isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
        isGlassTheme ? '' : themeStyles.secondaryBackground,
      )}>
        {items.map((item) => (
          <div className={classNames(styles.item, item.disabled ? styles.disabledItem : '')}>
            {item.itemContent}
          </div>
        ))}
      </div>
    </div>
  );
}


export default ButtonDD;
